import { FC } from 'react';
import { Divider } from '@mui/material';

export const AppDividerListItem: FC = () => {
  return <Divider component="li" />;
};
